<template>
    <div class="col-12 px-0 py-2 message" v-bind:class="{'first':isFirst}">
        <p class="font-weight-bold">{{message.messageSubjectLine}}</p>
        <p>{{message.messageContent}}</p>
        <div v-if="isOptOutAvailable" class="custom-control custom-checkbox">
            <input type="checkbox" class="theme-primary custom-control-input" :id="getBroadcastId('optOutId')" v-model="optOut">
            <label class="custom-control-label icon-label" :for="getBroadcastId('optOutId')">{{doNotShow}}</label>
        </div>
    </div>
</template>

<script>
    let instanceCount = 0;
    export default {
        name: "BroadcastMessage",

        emits: ['add-message', 'remove-message'],

        props: {
            message: Object,
            isFirst: Boolean,
            doNotShow: String
        },

        data: function() {
            return {
                optOut: false,
                instanceId: `broadcast-message-${instanceCount++}`,
            }
        },

        methods: {
            getBroadcastId: function(type) {
            return `${this.instanceId}-${type}`;
            }
        },

        computed: {
            isOptOutAvailable: function() {
                return this.message.messageTypeCd === "6" || this.message.messageTypeCd === "8";
            },

            optOutId: function() {
                return "optOut-" + this.message.messageID;
            }
        },

        watch: {
            optOut: function(val) {
                if (val) {
                    this.$emit('add-message', this.message.messageID);
                }
                else {
                    this.$emit('remove-message', this.message.messageID);
                }
            }
        }
    }
</script>

<style scoped>
    .message {
        border-top: 2px solid var(--account-row-border-color);
    }

    .message.first {
        border-top: none;
    }
</style>